var initialState = {
    byId: {},
    allIds: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.image) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.image
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
};